module.exports = __webpack_public_path__ + "img/3.300daa99.webp";